import Axios from 'axios';
import Cookies from 'js-cookie';
import {browser} from '@/lib/ua';
const UserInfo = Cookies.get('MT_USER_INFO');
const doLogin = {
  // 登录
  login(code, wxAuth) {
    if (!window.token) {
      if (UserInfo) {
        window.mtlogin();
      } else {
        if (browser.wx) {
          if (code == undefined || code == null || code == '') {
            location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5699bb5297ae3984&redirect_uri=${encodeURIComponent(document.URL)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
          } else {
            wxAuth();
          }
        } else {
          let preLoginUrl =
            process.env.PROJECT_BUILD_ENV === 'production'
              ? '//m.babytree.com' : '//m.9.babytree-test.com';
          location.href = `${preLoginUrl}/reg/signin.php?url=${encodeURIComponent(`http://m.meitun.com/mobile/system/bbtUnionLogin.htm?redirect_url=${encodeURIComponent(document.URL)}`)}`;
        }
      }
    }
  },
  //微信中自动授权
  bindAuth(wxcode, wxAuth) {
    if (browser.wx) {
      if (wxcode !== '' && wxcode !== undefined && wxcode !== null) {
        if (window.token === '' || window.token === undefined || window.token === null) {
          wxAuth();
        }
      }
    }
  },
  //设置cookie信息
  info(info, token) {
    Cookies.set('userInfo', info);
    window.localStorage.setItem('userinfo', info);
    window.localStorage.setItem('token', token);
  },
  //清空cookie信息
  clearCookies() {
    Cookies.remove('userInfo','');
    window.localStorage.removeItem('userInfo', '');
    window.localStorage.removeItem('token', '');
  },

  // base64解码函数
  base64Decode(str) {
    let c1, c2, c3, c4;
    const base64DecodeChars = new Array(
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
      -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57,
      58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6,
      7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
      37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1,
      -1, -1
    );
    let i = 0, len = str.length, string = '';

    while (i < len) {
      do {
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (
        i < len && c1 == -1
        );

      if (c1 == -1) break;

      do {
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff]
      } while (
        i < len && c2 == -1
        );

      if (c2 == -1) break;

      string += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

      do {
        c3 = str.charCodeAt(i++) & 0xff;
        if (c3 == 61)
          return string;

        c3 = base64DecodeChars[c3]
      } while (
        i < len && c3 == -1
        );

      if (c3 == -1) break;

      string += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));

      do {
        c4 = str.charCodeAt(i++) & 0xff;
        if (c4 == 61) return string;
        c4 = base64DecodeChars[c4]
      } while (
        i < len && c4 == -1
        );

      if (c4 == -1) break;

      string += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }
    return string;
  },
  // 获取app版本号
  getAppVersion() {
    let version = null;
    if (UserInfo && UserInfo != 'undefined' && UserInfo != '') {
      const MT_Array = UserInfo.split(',');
      if (MT_Array && MT_Array.length >= 2 && MT_Array[1] != null && MT_Array[1] != '') {
        version =  this.base64Decode(MT_Array[1]);
        version =  window.parseInt(version.replace(/\./g, ''),10);
      }
    }
    return version;
  }

};

export default doLogin;



// WEBPACK FOOTER //
// ./src/lib/do-login.js